import React, { Component } from 'react'
import liffHelper from '../utils/liffHelper'
import utils from '../utils/utils'
import CeApi from '../lib/ce_api'

const liff = liffHelper.getLiff()

export default class LIFFWindow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      liff_id: "1653882163-AbYgw2G5",
      init_success: false,
      profile: {},
      login_channel_id: "",
      email_input: [],
      disabled_email_input: false
    }
  }

  openLIFFWindow() {
    liffHelper.openWindow(this.textInput.value, false);
  }

  openLIFFWindowExternal() {
    liffHelper.openWindow(this.textInput.value, true);
  }

  async loginIfNot () {
    if (!await liff.isLoggedIn()) {
      // set `redirectUri` to redirect the user to a URL other than the front page of your LIFF app.
      await liff.login()
    }
  }

  async componentDidMount() {
    try {
      // liff id要從route抓
      let liffId = this.props.match.params.liff_id

      await liff.init({ liffId: liffId })

      await this.loginIfNot()

      let decodeToken = await liff.getDecodedIDToken()
      if(!decodeToken.aud) throw new Error("loss login_channel_id")
      let login_channel_id = decodeToken.aud

      let profile = await liff.getProfile()
      if(!profile || !profile.userId) return window.alert("獲取line個人資料失敗")

      let user = await CeApi.getUserByLineId(profile.userId, login_channel_id)
      if(!user || !user.email) return window.alert("獲取line個人資料失敗: email")

      this.setState({ init_success: true, login_channel_id, profile, email_input: user.email })
    } catch (e) {
      console.log(e)
      window.alert("line資料初始化失敗")
    }

    //await liffHelper.openWindow("https://www.twitch.tv/3rdgreatuncle", true)

    //this.setState({ profile })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.init_success !== this.state.init_success && this.state.init_success === true) {

    }
  }

  clickSubmit = async (event) => {
    let email = this.state.email_input
    let line_user_id = this.state.profile.userId
    let loginChannelId = this.state.login_channel_id

    try {
      let result = await CeApi.putLineUserEmail(line_user_id, loginChannelId, email)
      window.alert("email設定成功!, 即將關閉設定頁面")
      return liff.closeWindow()
    } catch (e) {
      window.alert("oops! 似乎發生了什麼錯誤, 請稍後嘗試")
    }
  }

  handleParamsChange = event => {
    let state = {}

    state[event.target.name] = event.target.value
    this.setState(state)
  }

  handleEmailChange = event => {
    let state = {}
    let email = event.target.value

    email = email.trim()
    state.email_input = email

    let emailValid = utils.validateEmail(email)
    if(emailValid) {
      state.disabled_email_input = false
      this.setState(state)
    } else {
      state.disabled_email_input = true
      this.setState(state)
    }
  }



  render() {
    return (
      <div className="page-content">
        <div className="col-lg-3" />
        <div className="col-lg-6">
          <div className="form-group">
            <label htmlFor="email_input">設定EMAIL:</label>
            <input name="email_input" type="text" className="form-control"
            id="email_input" placeholder="請輸入您的email" onChange={this.handleEmailChange} value={this.state.email_input}/>
          </div>
          <hr />
          <button type="button" className="btn btn-default" onClick={this.clickSubmit} disabled={this.state.disabled_email_input}>確認修改</button>
        </div>
        <div className="col-lg-3" />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ChangeEmail.js